<script setup lang="ts">
interface Props {
  variant?: 'primary' | 'secondary' | 'outline'
  disabled?: boolean
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  disabled: false,
  loading: false
})
</script>

<template>
  <button
    :class="[
      'min-h-touch px-6 py-3 rounded-lg font-medium transition-colors',
      'flex items-center justify-center gap-2',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      {
        'bg-vfr-red text-white hover:bg-red-700 active:bg-red-800': variant === 'primary',
        'bg-vfr-yellow text-vfr-dark hover:bg-yellow-500 active:bg-yellow-600': variant === 'secondary',
        'border-2 border-vfr-red text-vfr-red hover:bg-vfr-red hover:text-white': variant === 'outline'
      }
    ]"
    :disabled="disabled || loading"
  >
    <span v-if="loading" class="animate-spin h-5 w-5 border-2 border-current border-t-transparent rounded-full" />
    <slot />
  </button>
</template>
